import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCard } from '@angular/material/card';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'se-checkeditem',
    templateUrl: './se-checkeditem.component.html',
    styleUrls: ['./se-checkeditem.component.scss'],
    standalone: true,
    imports: [NgIf, MatCard, FormsModule],
})
export class SeCheckedItemComponent {
    // data members

    @Output()
    activeChange = new EventEmitter<boolean>();

    @Output()
    selectedChange = new EventEmitter<boolean>();

    @Input()
    title: string;

    @Input()
    description: string;

    @Input()
    active = false;

    @Input()
    selected = false;

    @Input()
    selectionVisible = true;

    @Input()
    border = '1px solid #898989';

    // public functions

    activeItem() {
        this.activeChange.emit(this.active);
    }

    selectItem() {
        this.selectedChange.emit(this.selected);
    }
}
